import { useCurrentRefinements, UseCurrentRefinementsProps } from 'react-instantsearch';

export const CurrentRefinementsVirtual = (props: UseCurrentRefinementsProps) => {
  useCurrentRefinements(props);
  return null;
};
